import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GridRowsProp } from "@mui/x-data-grid-pro";
import React from "react";
import { useTranslation } from "react-i18next";

interface OrderLinesTitleProp {
  selectedRow: GridRowsProp;
  enteredRowCount: number;
}

const EntryLinesHeader = React.memo(
  ({ selectedRow, enteredRowCount }: OrderLinesTitleProp) => {
    const theme = useTheme();
    const { t } = useTranslation(["orders", "common"]);

    const orderLinesTitleSx = {
      fontWeight: theme.tokens.FuelFontWeightSemibold,
      fontSize: theme.tokens.FuelFontSizeHeading4,
      color: theme.tokens.FuelColorTextPrimary,
    };

    const titleDivSx = {
      display: "flex",
      alignItems: "center",
      gap: theme.tokens.FuelSpacing2,
    };

    return (
      <div
        data-testid="order-lines-title-component"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: theme.tokens.FuelSpacing6,
          marginBottom: theme.tokens.FuelSpacing4,
        }}
      >
        <div style={titleDivSx}>
          <Typography data-testid="order-lines-title" sx={orderLinesTitleSx}>
            {t("orders:orderLines.orderEntryGrid.title")} ({enteredRowCount})
          </Typography>
          {selectedRow.length > 0 && (
            <Typography
              data-testid="order-lines-selected-rows-count"
              variant="caption"
              sx={{
                color: theme.tokens.FuelColorTextIcon,
              }}
            >
              {selectedRow.length} {t("orders:orderLines.orderGrid.selected")}
            </Typography>
          )}
        </div>
      </div>
    );
  }
);

export default EntryLinesHeader;
